import type { InboxProvider } from "../api/connectionHub.types";

const CDN_IMAGE_BASE = "https://assets.clickmerito.com/images";

export const PROVIDER_LOGO_URLS: Partial<Record<InboxProvider, string>> = {
  gmail: `${CDN_IMAGE_BASE}/gmail.png`,
  outlook: `${CDN_IMAGE_BASE}/outlook.png`,
};
